import React, { useState, useEffect } from 'react';
import '../../../../../styles/contentCalendar/components/detailPost/style.scss';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Fade } from "react-reveal";
import {
  setPublishDate, setPublishHour,
  setAlertNotification, setAlertNotificationDate, setAlertNotificationHour,
  setImageData, setDescription as setDescriptionPost, setHahstags,
  setNewPost as setNewPostSlice,
  resetPost
} from '../../../../../../reducers/newPost';
import { formatDateMoment, formatHourMoment, socialNetworksConst } from '../../../../../services/values';
import Text from '../../../../../share-components/text/text';
import '../../../../../share-components/toogle.scss';
import '../../../../../share-components/skeleton.scss';
import ImageList from '../imageList/imageList';
import { updatePostList } from '../../../../../../reducers/postsCompany';
import { setShowAlert } from '../../../../../../reducers/showAlert';
import { patchRequestCollaborator } from '../../../../../services/requestLib';
import { resetImageSelectedForPost } from '../../../../../../reducers/imageSelectedForPost';
import UploadFiles from '../uploadFiles/uploadFiles';

function DetailPost({ closeModal, SendSocket }) {
  const currentDate = moment().format(formatDateMoment);
  const statusUser = useSelector((state) => state.statusUser.value);
  const activeCollaboratorMode = useSelector((state) => state.activeCollaboratorMode.value);
  const userData = useSelector((state) => state.userData.value);
  const activeCompanyProfile = useSelector((state) => state.activeCompanyProfile.value);
  const postsCompany = useSelector((state) => state.postsCompany.value); 

  // eslint-disable-next-line no-unused-vars
  const [postsCompanyState, setPostsCompanyState] = useState({});
  const postData = useSelector((state) => state.newPost.value);
  const [newPost, setNewPost] = useState({...postData});
  const imageSelectedForPost = useSelector((state) => state.imageSelectedForPost.value);

  /* Importing the useDispatch hook from the react-redux library. */
  const dispatch = useDispatch();

  const handlerResetPost = () => {
    dispatch(resetPost());
  };

  const handlerResetImageSelectedForPost = () => {
    dispatch(resetImageSelectedForPost());
  };

  const handlerCloseModal = () => {
    handlerResetPost();
    handlerResetImageSelectedForPost();
    closeModal();
  };

  const handlerSetAlertNotification = (infoPost) => {
    dispatch(setAlertNotification(infoPost));
  };
  
  const handlerSetNewPost = (infoPost) => {
    dispatch(setNewPostSlice(infoPost));
  };

  const handlerSetAlertNotificationDate = (infoPost) => {
    dispatch(setAlertNotificationDate(infoPost));
  };

  const handlerSetAlertNotificationHour = (infoPost) => {
    dispatch(setAlertNotificationHour(infoPost));
  };

  const handlerSetPublishDate = (infoPost) => {
    dispatch(setPublishDate(infoPost));
  };

  const handlerSetPublishHour = (infoPost) => {
    dispatch(setPublishHour(infoPost));
  };

  const handlerSetImageData = (infoPost) => {
    dispatch(setImageData(infoPost));
  };

  const handlerSetDescription = (infoPost) => {
    dispatch(setDescriptionPost(infoPost));
  };
   
  const handlerSetHahstags = (infoPost) => {
    dispatch(setHahstags(infoPost));
  };

  const handlerUpdatePostList = (infoPostList) => {
    dispatch(updatePostList(infoPostList));
  };

  const handlerSetShowAlert = (infoAlert) => {
    dispatch(setShowAlert(infoAlert));
  };

  const openAlert = (typeAlert, textAlert) => {
    const object = {
      typeAlert: typeAlert,
      textAlert: textAlert
    };

    handlerSetShowAlert(object);
  };

  const handlerChangeDescriptionOrHashtahs = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "description":
          handlerSetDescription(value);
        break;
      case "hahstags":
          handlerSetHahstags(value);
        break;
      default:
        break;
    }
  };

  const [contentIdea, setContentIdea] = useState("");  
  const [description, setDescription] = useState("");
  // const [hashtags, setHashtags] = useState("");

  useEffect(() => {
    setContentIdea(newPost.contentIdea);
    setDescription(newPost.postText);
    // setHashtags(newPost.hashtags);
  }, [newPost]);

  const [enableAlarm, setEnableAlarm] = useState(false);

  const handlerToogleAlarm = () => {
    if (enableAlarm) {
      setEnableAlarm(false);
      handlerSetAlertNotification(false);
    }
    
    if (!enableAlarm) {
      setEnableAlarm(true);
      handlerSetAlertNotification(true);
    }
  };

  const handlerSetDateTimePublish = (e) => {
    const { name, valueAsNumber } = e.target;

    switch (name) {
      case "date-publish": {
        const formatDate = moment.utc(valueAsNumber).format(formatDateMoment);
        const isValidDate = moment(formatDate).isValid();

        if (isValidDate) {
          handlerSetPublishDate(formatDate);
        } else {
          handlerSetPublishDate("");
        }

        break;
      }
      case "time-publish": {
        const formatHour = moment.utc(valueAsNumber).format(formatHourMoment);

        if (formatHour !== "invalid-date") {
          handlerSetPublishHour(formatHour);
        } else {
          handlerSetPublishHour("");
        }

        break;
      }
      default:
        break;
    }
  };

  const handlerSetDateTimeNotification = (e) => {
    const { name, valueAsNumber } = e.target;

    switch (name) {
      case "date-notification": {
        const formatDate = moment.utc(valueAsNumber).format(formatDateMoment);
        const isValidDate = moment(formatDate).isValid();

        if (isValidDate) {
          handlerSetAlertNotificationDate(formatDate);
        } else {
          handlerSetAlertNotificationDate("");
        }

        break;
      }
      case "time-notification": {
        const formatHour = moment.utc(valueAsNumber).format(formatHourMoment);

        if (formatHour !== "invalid-date") {
          handlerSetAlertNotificationHour(formatHour);
        } else {
          handlerSetAlertNotificationHour("");
        }

        break;
      }
      default:
        break;
    }
  };

  const [openImageList, setOpenImageList] = useState(false);

  const handlerOpenImageList = () => {
    if (openImageList) {
      setOpenImageList(false);
    }
    if (!openImageList) {
      setOpenImageList(true);
    }
  };

  const isFormDataValid = () => {
    const isValid =
      newPost.postText !== "" &&
      newPost.hashtags !== "" &&
      newPost.publishHour !== "" &&
      newPost.publishDate !== "" && !moment.utc(currentDate).isSameOrAfter(newPost.publishDate);

    return isValid;
  };

  const validateDate = (date) => {
    const isValidDate = moment.utc(date).isValid();

    if (isValidDate) {
      if (moment(currentDate).isSameOrAfter(date)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handlerUpdatePostListCompany = async () => {
    const user = {
      email: userData.email,
      password: userData.password,
      token: userData.token,
      typeAccess: 1
    };

    const sendData = {
      id: activeCompanyProfile.id,
      postList: postsCompany.postList,
    };

    const responseUpdatePostCompany = await patchRequestCollaborator('company-posts', user, sendData);
    if (responseUpdatePostCompany.status === 200 && responseUpdatePostCompany.data.status === true) {
      
      SendSocket({
        action: 'send-message',
        data: {
          id: activeCompanyProfile.id,
          user: userData.user,
          message: {
            type: 'UPDATE',
            table: 'company-posts',
            sendFromAdminView: true,
            sendFromCollaboratorView: false,
            companyOwner: userData.user,
            idCompanyOwner: activeCompanyProfile.id,
            userSendUpdate: userData.user,
            isAdmin: !activeCollaboratorMode.collaboratorMode,
            data: { 
              user: postsCompany.user,
              id: activeCompanyProfile.id,
              email: postsCompany.email,
              maxGenerateContentPost: postsCompany.maxGenerateContentPost,
              maxGenerateSpecificPost: postsCompany.maxGenerateSpecificPost,
              maxGenerateVideoPosts: postsCompany.maxGenerateVideoPosts,
              postList: postsCompany.postList
            }
          }
        }
      });

      handlerCloseModal();
      openAlert("success", "Success");
    } else {
      openAlert("danger", "Error, try again");
    }
  };

  const [confirm, setConfirm] = useState(false);

  const handlerSavePost = () => {
    handlerUpdatePostList(newPost);
    setConfirm(true);
  };

  useEffect(() => {
    if (imageSelectedForPost.uuid !== "") {
      handlerSetImageData(imageSelectedForPost);
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageSelectedForPost]);

  useEffect(() => {
    setNewPost({...postData});
  }, [postData]);

  const handlerUpdateCurrentPost = (newData) => {
    const getCurrentPost = newData.postList.find((x) => x.id === newPost.id);
    if (getCurrentPost) {
      setNewPost({...getCurrentPost});
      handlerSetNewPost(getCurrentPost);
    } else {
      handlerSetNewPost(postData);
    }
  };

  useEffect(() => {
    setPostsCompanyState(postsCompany);
    handlerUpdateCurrentPost(postsCompany);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postsCompany]);

  const handlerVerifyPlanId = () => {
    const validServicePlanId = 'b28e7ae4-285e-4915-bfcc-b35ed097465f';
    if (statusUser.servicePlan === validServicePlanId) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className="content-views">
      <Fade duration={600} opposite>
        <>
          <div className="modal-content d-block">
            <div className="header-detail-post">
              <Text type="subtitle" translateText={"detail_post_title"} />
            </div>
            <div className="detail-post-container">
              <div className="detail-block">
                <Text type="text" translateText={"file_title"} />
              </div>
              <div className="detail-block-img">
                <div>
                  <div className="container-skeleton-or-image">

                    {imageSelectedForPost.uuid !== "" ? (
                      <img
                        src={imageSelectedForPost.urlThumbnail}
                        alt="file selected"
                        className="demo-view-file"
                      />
                    ) : (
                      <>
                        {newPost.urlThumbnailFile ? (
                          <img
                            src={newPost.urlThumbnailFile}
                            alt="file post"
                            className="demo-view-file"
                          />
                        ) : (
                          <div className="skeleton"></div>
                        )}
                      </>
                    )}

                  </div>
                </div>
                {handlerVerifyPlanId() && (
                  <div className="d-flex flex-row gap-10">
                    <button className="btn-select-file" onClick={() => handlerOpenImageList()}>
                      <Text type="text" translateText={"select_file_text"} />
                    </button>
                    <UploadFiles importButton={"detail post"} SendSocket={SendSocket}/>
                  </div>
                )}
              </div>
              <div className={`block-image-list overflow-scroll ${openImageList ? 'show' : ''}`}>
                <Text type="text" translateText={"gallery_title"} />
                <ImageList isCollapse={openImageList} SendSocket={SendSocket} fromView={'modal-post'} />
              </div>
              <div className="detail-block">
                <Text type="text" translateText={"social_media_detail_post"} />
                <div className='d-flex flex-row gap-10'>
                  {newPost.typePost === "Weekly Post" && (
                    <>
                      {newPost.groupPost === "Content post" && (
                        socialNetworksConst.filter((x) => x.group === 1).map((sn) => (
                          <img
                            key={sn.id}
                            className="social-icon-header"
                            src={sn.urlIcon}
                            alt="Weekly posts - Content post"
                          />
                        ))
                      )}

                      {newPost.groupPost === "Video content post" && (
                        socialNetworksConst.filter((x) => x.group === 2).map((sn) => (
                          <img
                            key={sn.id}
                            className="social-icon-header"
                            src={sn.urlIcon}
                            alt="Weekly posts - Video content post"
                          />
                        ))
                      )}
                    </>
                  )}

                  {newPost.typePost === "Specific Post" && (
                    <img
                      className="social-icon-header"
                      src={newPost.imgSocialNetwork}
                      alt="Specific posts"
                    />
                  )}
                </div>
              </div>
              <div className="detail-block">
                {newPost.typePost === "Weekly Post" && (
                  <>
                    {(newPost.typePost === "Weekly Post" && newPost.groupPost === "Content post") && (
                      <Text type="text" translateText={"content_idea_detail_post"} />
                    )}
                    {(newPost.typePost === "Weekly Post" && newPost.groupPost === "Video content post") && (
                      <Text type="text" translateText={"category_description_detail_post"} />
                    )}
                  </>
                )}
                {newPost.typePost !== "Weekly Post" && (
                  <Text type="text" translateText={"content_idea_detail_post"} />
                )}
                <div className="d-flex flex-column" style={{ width: '70%' }}>
                  <textarea
                    className="textarea-detail-post text-area-input"
                    rows={2}
                    value={contentIdea}
                    disabled={true}
                  >
                  </textarea>
                </div>
              </div>
              <div className="detail-block">
                {newPost.typePost === "Weekly Post" && (
                  <>
                    {(newPost.typePost === "Weekly Post" && newPost.groupPost === "Content post") && (
                      <Text type="text" translateText={"description_detail_post"} />
                    )}
                    {(newPost.typePost === "Weekly Post" && newPost.groupPost === "Video content post") && (
                      <Text type="text" translateText={"content_idea_detail_post"} />
                    )}
                  </>
                )}
                {newPost.typePost !== "Weekly Post" && (
                  <Text type="text" translateText={"description_detail_post"} />
                )}
                <div className="d-flex flex-column" style={{ width: '70%' }}>
                  <textarea
                    className={`textarea-detail-post text-area-input ${newPost.postText === "" ? 'invalid-answer' : ''}`}
                    rows={handlerVerifyPlanId() ? 6 : 8}
                    name="description"
                    onChange={(e) => handlerChangeDescriptionOrHashtahs(e)}
                    value={description}
                    disabled={confirm}
                  >
                  </textarea>
                  {newPost.postText === "" && (
                    <Text type="small" inyectClass={"text-danger mb-1 mt-1"} translateText={"description_alert_detail_post"} />
                  )}
                </div>
              </div>
              {/*
                <div className="detail-block">
                  <Text type="text">
                    Hashtags
                  </Text>
                  <div className="d-flex flex-column" style={{ width: '70%' }}>
                    <textarea
                      className={`textarea-detail-post text-area-input ${newPost.hashtags === "" ? 'invalid-answer' : ''}`}
                      rows={4}
                      name="hahstags"
                      onChange={(e) => handlerChangeDescriptionOrHashtahs(e)}
                      value={hashtags}
                      disabled={confirm}
                    >
                    </textarea>
                    {newPost.hashtags === "" && (
                      <small className="text-danger mb-1 mt-1">
                        Hashtags's text box should not be empty
                      </small>
                    )}
                  </div>
                </div>
              */}
            {handlerVerifyPlanId() && (
              <>
                <div className="detail-block">
                  <Text translateText={"daytime_to_publish_detail_post"} />
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column">
                      <input
                        type='date'
                        className={`mb-1 ${validateDate(newPost.publishDate) ? 'invalid-answer' : ''}`}
                        name="date-publish"
                        onChange={(e) => handlerSetDateTimePublish(e)}
                        disabled={confirm}
                        value={newPost.publishDate}
                      />
                      {validateDate(newPost.publishDate) && (
                        <Text type="small" inyectClass={"text-danger mb-1"} translateText={"daytime_to_publish_alert_date_detail_post"} />
                      )}
                    </div>
                    <input
                      type='time'
                      className="mb-1"
                      name="time-publish"
                      onChange={(e) => handlerSetDateTimePublish(e)}
                      disabled={confirm}
                      value={newPost.publishHour}
                    />
                  </div>  
                </div>
                <div className="detail-block">
                  <Text type="text" translateText={"enable_alarm_detail_post"} />
                  <button
                    className={`btn-toogle ${enableAlarm ? 'active' : ''}`} 
                    onClick={() => handlerToogleAlarm()}
                  >
                    <div className="circle-toogle">
                    </div>
                  </button>
                </div>
              </>
            )}
          </div>
          {handlerVerifyPlanId() && (
            <>
              {enableAlarm && (
                <div className="detail-block">
                  <Text type="small" translateText={"daytime_to_alarm_detail_post"} />
                  <div className="d-flex flex-column">
                    <input
                      type='date'
                      className="mb-1"
                      name="date-notification"
                      onChange={(e) => handlerSetDateTimeNotification(e)}
                    />
                    <input
                      type='time'
                      className="mb-1"
                      name="time-notification"
                      onChange={(e) => handlerSetDateTimeNotification(e)}
                    />
                  </div>  
                </div>
              )}
            </>
          )}
          </div>
          <div className="action-btn-form">
            {handlerVerifyPlanId() ? (
              <>
                {!confirm ? (
                  <>
                    <button
                      className="two-btn-modal"
                      onClick={() => handlerCloseModal()}>
                      <Text type="text" translateText={"close_button"} />
                    </button>
                    <button
                      className={`two-btn-modal ${!isFormDataValid() ? 'btn-disabled' : ''}`}
                      onClick={() => handlerSavePost()}
                      disabled={!isFormDataValid()}
                    >
                      <Text type="text" inyectClass={"text-white"} translateText={"confirm_btn"} />
                    </button>
                  </>
                ) : (
                  <button
                    className={`one-btn-modal btn-primary`}
                    onClick={() => handlerUpdatePostListCompany()}
                  >
                    <Text type="text" translateText={"save_btn"} />
                  </button>
                )}
              </>
            ) : (
              <button
                className="one-btn-modal btn-secondary"
                onClick={() => handlerCloseModal()}>
                <Text type="text" translateText={"close_button"} />
              </button>
            )}
          </div>
        </>
      </Fade>
    </div>
  )
};

DetailPost.propTypes = {
  closeModal: PropTypes.func.isRequired,
  SendSocket: PropTypes.func.isRequired,
};

export default DetailPost;
